<template>
<div class="input-group" :class="_class">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
        },
    },
    computed: {
        _class: function() {
            let _class = []

            if(this.size) {
                _class.push('input-group-'+this.size)
            }

            return _class
        }
    }
}
</script>

<style>

</style>